export default "/7ee56fc642439642e071ad6692a1a8b95a874bf4/fbf1cfaf74329f9a6a1fed67972e7c52.svg";